import { getAuthorization } from 'controllers/controller';
import { getJobTalentCountsByDaysHoursService } from 'services/dashboard/getJobTalentCountsByDaysHours';

export const getJobTalentCountsByDaysHours = async (
  jobId,
  last,
  talentStatus
) => {
  const authorization = getAuthorization();

  const { data } = await getJobTalentCountsByDaysHoursService(authorization, {
    jobId,
    last,
    talentStatus,
  });

  return data.response.resultMap;
};

export const formatDayHoursHeatmap = (response) => {
  if (!Object.keys(response).length) {
    return [];
  }

  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  const hours = new Array(24).fill(0).map((v, i) => i);

  const data = [];

  days.forEach((day, index) => {
    const hoursObj = response[day]
      ? response[day].reduce(
          (acc, { hour, count }) => ({ ...acc, [hour]: count }),
          {}
        )
      : {};

    hours.forEach((hour) => {
      if (hoursObj[hour]) {
        data.push([index, hour, hoursObj[hour]]);
      } else {
        data.push([index, hour, 0]);
      }
    });
  });

  return data;
};
